import { LoaderIcon } from 'fitify-ui/src/Icon/outline/LoaderIcon'
import { useRouter } from 'next/router'
import type { PropsWithChildren } from 'react'

import { StyledContainer } from 'components/RouteGuard/RouteGuard.Styled'
import { useAuthContext } from 'contexts/AuthContext'

export const RouteGuard = ({ children }: PropsWithChildren) => {
  const { isAuthLoading, isLoggedIn } = useAuthContext()
  const router = useRouter()

  const isLoginPage = router.pathname === '/'

  if (isAuthLoading || (!isLoginPage && !isLoggedIn)) {
    return (
      <StyledContainer>
        <LoaderIcon />
      </StyledContainer>
    )
  }

  return children
}
